export default "__VITE_ASSET__DKQg1t4V__"